function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Chat Sms Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8,-7.99360578e-15 C12.390797,-7.99360578e-15 16,2.64657156 16,6 C16,7.65978134 15.1061305,9.19537394 13.5770667,10.3087352 L13.9595686,13.1625787 C14.0173708,13.5938406 13.5348772,13.8880177 13.1779813,13.6391137 L10.4264961,11.7201917 C10.2122427,11.7710053 9.99254249,11.8155566 9.76693838,11.8540732 C9.19210558,11.9507642 8.60022232,12 8,12 C3.60920297,12 0,9.35342844 0,6 C0,2.64657156 3.60920297,-7.99360578e-15 8,-7.99360578e-15 Z M8,1 C4.10629464,1 1,3.27779683 1,6 C1,8.72220317 4.10629464,11 8,11 C8.54475094,11 9.08114912,10.9553797 9.59985177,10.8681318 C9.87613365,10.8209617 10.1425176,10.7637947 10.3989271,10.696417 C10.540736,10.6591534 10.6917544,10.6860123 10.8120187,10.7698863 L12.8173835,12.1684542 L12.5454314,10.1394213 C12.5200639,9.95015454 12.6047149,9.76296661 12.7635863,9.65701724 C14.1885813,8.70670602 15,7.39148393 15,6 C15,3.27779683 11.8937054,1 8,1 Z M4.4839,4.946 C5.03618475,4.946 5.4839,5.39371525 5.4839,5.946 L5.4839,5.979 C5.4839,6.53128475 5.03618475,6.979 4.4839,6.979 C3.93161525,6.979 3.4839,6.53128475 3.4839,5.979 L3.4839,5.946 C3.4839,5.39371525 3.93161525,4.946 4.4839,4.946 Z M7.9839,4.946 C8.53618475,4.946 8.9839,5.39371525 8.9839,5.946 L8.9839,5.979 C8.9839,6.53128475 8.53618475,6.979 7.9839,6.979 C7.43161525,6.979 6.9839,6.53128475 6.9839,5.979 L6.9839,5.946 C6.9839,5.39371525 7.43161525,4.946 7.9839,4.946 Z M11.4839,4.946 C12.0361847,4.946 12.4839,5.39371525 12.4839,5.946 L12.4839,5.979 C12.4839,6.53128475 12.0361847,6.979 11.4839,6.979 C10.9316153,6.979 10.4839,6.53128475 10.4839,5.979 L10.4839,5.946 C10.4839,5.39371525 10.9316153,4.946 11.4839,4.946 Z",
  id: "chat-sms-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "chat-sms-Icon/Global/sms",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chat-sms-Swatches/Midnight",
  transform: "translate(4.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "chat-sms-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#chat-sms-path-1"
})));

var SvgChatSms = function SvgChatSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-sms.fb8af717.svg";
export { ForwardRef as ReactComponent };